<template>
    <router-link :to="{ name: 'accessory-sheet-summary', params: {id: datas.identifier, name: slugifyName(datas), saveRoute: saveRoute}}" class="accessory-card-light">
        <img :src="picture" alt="" class="picture" />
        <div class="category" v-if="categoryAccessory">{{ categoryAccessory }}</div>
        <div class="title">
          {{ datas.name ? datas.name : 'n.a' }}
          <p v-if="datas.variantTitle">{{ datas.variantTitle }}</p>
        </div>
    </router-link>
</template>

<script>
    import mediaService from '@/services/akeneo/media'
    import {mapState} from "vuex";

    const defaultPicture = require('@/assets/img/no_image_available.jpg');
    const loadingGif = require('@/assets/img/pix.png');

    export default {
        name: 'AccessoryCardLight',
        props: {
            datas: {
                type: Object
            },
            saveRoute: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                picture: defaultPicture,
              categoryAccessory:'',
            }
        },
      computed: {
        ...mapState({
          categories: state => state.settings.categories,
        }),
      },
        watch: {
            datas() {
                this.picture = defaultPicture;
                this.fetchPicture();
            }
        },
        created() {
            this.fetchDatas();
        },
        methods: {
          fetchDatas() {
            if (this.datas.thumbnail) {
              this.picture = this.datas.thumbnail;
            }

            var slugCategory=this.datas.categories[0]
            if (slugCategory) {
              var category=this.categories.find(x=>x.code===slugCategory)
              this.categoryAccessory = category.label;
            }
          },
        },
    }
</script>

<style lang="scss">
    .accessory-card-light {
        position: relative;
        display: inline-block;
        text-align: center;

        .picture {
            width: auto;
            height: 80px;
            margin: 20px 0
        }

        .category {
            font-size: 10px;
            font-weight: 500;
            line-height: 1.3;
            text-transform: uppercase;
            color: $cloudy-grey;
        }

        .title {
            @include small-title($black);
            line-height: 18px;
            margin: 5px 0;
        }
    }
</style>